import React from 'react';
import Proptypes from 'prop-types';

import theme from '../../themes/tradeRev/theme';
import { StyledBackButton, Section, PageTitle, StyledHeader } from './Styles';

const propTypes = {
  title: Proptypes.string.isRequired,
  testId: Proptypes.string.isRequired,
  onBackClick: Proptypes.func,
  headerBgColor: Proptypes.string,
  headerColor: Proptypes.string,
  headerHeight: Proptypes.string
};

const defaultProps = {
  onBackClick: null,
  headerBgColor: theme.COLORS.BASE_INVERTED,
  headerColor: theme.COLORS.BASE,
  headerHeight: '54px'
};

const Header = ({
  title,
  testId,
  onBackClick,
  headerBgColor,
  headerColor,
  headerHeight
}) => (
  <StyledHeader
    headerBgColor={headerBgColor}
    headerColor={headerColor}
    headerHeight={headerHeight}
    data-testid={testId}
  >
    <Section data-testid="header-section">
      {onBackClick !== null && (
        <StyledBackButton
          clickHandler={onBackClick}
          color={headerColor}
          className={`${testId}-button`}
        />
      )}
      <PageTitle data-testid="header-page-title">{title}</PageTitle>
    </Section>
  </StyledHeader>
);

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
